import React from 'react';

const TitleBar = () => {
  return (
    <div className="w-full border-b border-slate-200 bg-white/95 backdrop-blur">
      <div className="mx-auto flex max-w-6xl items-center justify-center gap-1.5 px-4 py-1.5 sm:gap-2 sm:py-3">
        <span className="text-sm font-semibold text-blue-900 sm:text-lg">ERP Portal</span>
        <span className="h-1 w-1 rounded-full bg-yellow-400 sm:h-1.5 sm:w-1.5" aria-hidden="true" />
      </div>
    </div>
  );
};

export default TitleBar;
